import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 서버에서 발급받은 인증 토큰
    accessToken: null,
    // 서버에서 발급받은 리프레쉬 토큰
    refreshToken: null,
    // 로그인 사용자 정보
    loginUser: {
      loginId: null,
      name: null,
      role: null
    }
  },
  getters: {
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    loginUser: state => state.loginUser
  },
  mutations: {
    SET_ACCESS_TOKEN (state, accessToken) {
      state.accessToken = accessToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    },
    SET_REFRESH_TOKEN (state, refreshToken) {
      state.refreshToken = refreshToken
    },
    SET_LOGIN_USER (state, loginUser) {
      state.loginUser = loginUser
    }
  },
  actions: {
    /**
     * 관리자 시스템에 로그인 한다
     * @param context
     * @param payload
     * @returns {Promise}
     */
    doLogin (context, payload) {
      return axios.post('/setting/auth/login', payload)
        .then((response) => {
          context.commit('SET_ACCESS_TOKEN', response.data.result.token)
          context.commit('SET_REFRESH_TOKEN', response.data.result.refreshToken)
          context.commit('SET_LOGIN_USER', response.data.result.user)
          return response
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    /**
     * 관리자 시스템에서 로그아웃 한다
     * @param context
     */
    doLogout (context) {
      context.commit('SET_ACCESS_TOKEN', null)
      context.commit('SET_REFRESH_TOKEN', null)
      context.commit('SET_LOGIN_USER', null)
    }

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js